module.exports = __webpack_public_path__ + "assets/img/arrowDownIcon.6c64bf73.svg";